import React, { FC } from 'react';
import { Text } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';

interface BatchDetailsNCFilePerformanceUtilizationProps {}

const BatchDetailsNCFilePerformanceUtilization: FC<BatchDetailsNCFilePerformanceUtilizationProps> = () => {
  return (
    <DetailsPageWrapper title="Batch">
      <Text>BatchDetailsNCFilePerformanceUtilization</Text>
    </DetailsPageWrapper>
  );
};

export { BatchDetailsNCFilePerformanceUtilization };
